export default __webpack_public_path__ + "static/media/DSC00024.4b82b086.JPG";